module.exports = __webpack_public_path__ + "assets/img/title-5dc9ec6c.png";